export const nameOnWalletProducts = ['BFs', 'MiniBFs'];
export const nameOnAllPrintProducts = [
  'BFs',
  'MiniBFs',
  'MiniPac',
  '3.5x5',
  '4x5',
  '4x6 w/(4) 1"x1.5" BFs',
  '5x7',
  '8x10',
  '10x13',
];

export interface JobOrderServiceUpsertModel {
  id: number | null;
  price: number;
  orderServiceId: number;
  jobId: number;
  enabled: boolean;
}
export interface JobOrderServiceClientUpsertModel extends Partial<JobOrderServiceUpsertModel> {
  name: string;
  description: string;
  imageLevelService: boolean;
  minimumPrice: number | null;
}

export interface JobOrderServiceDisplayModel {
  id?: number | null;
  price: number;
  minimumPrice: number | null;
  name: string;
  code: string;
  description: string;
  orderServiceId: number;
  jobId: number;
  enabled: boolean;
  imageLevelService: boolean;
  allowRetouch: boolean;
  allowNameOnAllPrints: boolean;
  allowNameOnWallets: boolean;
  nameOnAllPrintsCost: number;
  nameOnWalletsCost: number;
  type: 'prepay' | 'hosted';
}
